if (!customElements.get('mobile-carousel')) {
  customElements.define(
    'mobile-carousel',
    class MobileCarousel extends HTMLElement {
      constructor() {
        super();

        this.slides = this.innerHTML;
        this.carousel = new window.Splide(this, {
          arrows: true,
          pagination: false,
          perPage: 1,
          perMove: 1,
          arrowPath:
            'M31 20.5 10.85 40 8 37.242 25.3 20.5 8 3.758 10.85 1l17.3 16.742L31 20.5Z',
          classes: {
            arrows: 'splide__arrows absolute w-full top-[40%] left-0',
            arrow: 'splide__arrow h-10 w-10 rounded-none opacity-100',
            prev: 'left-0 splide__arrow--prev',
            next: 'right-0 splide__arrow--next'
          },
          mediaQuery: 'min',
          breakpoints: {
            1024: {
              destroy: true
            }
          }
        });
      }

      connectedCallback() {
        this.generateCarousel();
      }

      generateCarousel() {
        this.innerHTML = '';
        const list = document.createElement('div');
        list.classList.add(
          'splide__list',
          'lg:!flex',
          'lg:justify-center',
          'lg:gap-x-20',
          'lg:gap-y-10',
          'lg:w-full',
          'lg:mx-auto'
        );

        const track = document.createElement('div');
        track.classList.add('splide__track', 'lg:w-full');

        list.innerHTML = this.slides;

        const productCount = list.children.length;

        if (productCount === 3) {
          list.classList.remove('lg:gap-x-20');
          list.classList.add('lg:gap-x-10', 'xl:gap-x-20');
        }

        if (productCount > 3) {
          list.classList.remove('lg:flex-wrap', 'lg:gap-x-20');
          list.classList.add(
            'lg:flex-wrap',
            'lg:!px-18',
            'lg:gap-x-10',
            'xl:gap-x-20'
          );
        }

        track.append(list);
        this.append(track);

        this.carousel.mount();
      }
    }
  );
}
